var map = {
	"./France": [
		"./views/mobile/worldCity/layout/map/name/France.json",
		12
	],
	"./France.json": [
		"./views/mobile/worldCity/layout/map/name/France.json",
		12
	],
	"./Germany": [
		"./views/mobile/worldCity/layout/map/name/Germany.json",
		13
	],
	"./Germany.json": [
		"./views/mobile/worldCity/layout/map/name/Germany.json",
		13
	],
	"./India": [
		"./views/mobile/worldCity/layout/map/name/India.json",
		14
	],
	"./India.json": [
		"./views/mobile/worldCity/layout/map/name/India.json",
		14
	],
	"./Iran": [
		"./views/mobile/worldCity/layout/map/name/Iran.json",
		15
	],
	"./Iran.json": [
		"./views/mobile/worldCity/layout/map/name/Iran.json",
		15
	],
	"./Italy": [
		"./views/mobile/worldCity/layout/map/name/Italy.json",
		16
	],
	"./Italy.json": [
		"./views/mobile/worldCity/layout/map/name/Italy.json",
		16
	],
	"./Japan": [
		"./views/mobile/worldCity/layout/map/name/Japan.json",
		17
	],
	"./Japan.json": [
		"./views/mobile/worldCity/layout/map/name/Japan.json",
		17
	],
	"./Korea": [
		"./views/mobile/worldCity/layout/map/name/Korea.json",
		18
	],
	"./Korea.json": [
		"./views/mobile/worldCity/layout/map/name/Korea.json",
		18
	],
	"./Russia": [
		"./views/mobile/worldCity/layout/map/name/Russia.json",
		19
	],
	"./Russia.json": [
		"./views/mobile/worldCity/layout/map/name/Russia.json",
		19
	],
	"./Spain": [
		"./views/mobile/worldCity/layout/map/name/Spain.json",
		20
	],
	"./Spain.json": [
		"./views/mobile/worldCity/layout/map/name/Spain.json",
		20
	],
	"./UK": [
		"./views/mobile/worldCity/layout/map/name/UK.json",
		21
	],
	"./UK.json": [
		"./views/mobile/worldCity/layout/map/name/UK.json",
		21
	],
	"./USA": [
		"./views/mobile/worldCity/layout/map/name/USA.json",
		22
	],
	"./USA.json": [
		"./views/mobile/worldCity/layout/map/name/USA.json",
		22
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./views/mobile/worldCity/layout/map/name lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;